


































import { computed, defineComponent, PropType } from '@vue/composition-api';

const name = 'ttam-tracking-brand-safety-select';

export default defineComponent({
  name,

  props: {
    value: { type: Number, default: undefined },
    disabled: { type: Boolean, default: false },
    options: {
      type: Array as PropType<
        {
          value: string;
          label: string;
          disabled: boolean;
          hintKey?: string;
          linkKey?: string;
          linkUrl?: string;
          linkPlace?: string;
        }[]
      >,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const _type = computed({
      get: () => props.value || '',
      set: val => {
        ctx.emit('change', val);
        ctx.emit('input', val);
      },
    });

    return {
      _type,
    };
  },
});
